/** Retry-After is seconds or an HTTP date. Never retry before the server's time. */
export function retryAfterMs(value: unknown, now = Date.now()): number | null {
  if (typeof value !== "string" && typeof value !== "number") return null;
  const raw = String(value).trim();
  if (!raw) return null;
  const seconds = Number(raw);
  if (Number.isFinite(seconds)) return seconds >= 0 ? seconds * 1000 : null;
  const date = Date.parse(raw);
  return Number.isFinite(date) ? Math.max(0, date - now) : null;
}

export function apiRetryDelay(attempt: number, error: unknown): number {
  const response = (error as { response?: { status?: number; headers?: Record<string, unknown> } })
    ?.response;
  if (response?.status === 429) {
    return retryAfterMs(response.headers?.["retry-after"]) ?? 60_000;
  }
  return Math.min(1000 * 2 ** attempt, 30_000);
}
